import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { loginUrl } from "@/features/auth/api";
import { safeReturnPath } from "@/lib/redirect";

export const Route = createFileRoute("/login")({
  component: Login,
  validateSearch: (search: Record<string, unknown>) => {
    const redirect = search.redirect;
    return { redirect: typeof redirect === "string" ? redirect : undefined };
  },
});

function Login() {
  const { t } = useTranslation();
  const { redirect } = Route.useSearch();

  // Validated here as well as server-side. The server is what actually
  // refuses an off-site redirect; this stops the app from ever building
  // a link it knows will be rejected, which would silently drop somebody
  // on the dashboard with no explanation.
  const returnTo = safeReturnPath(redirect);

  return (
    <main id="main" className="mx-auto flex min-h-dvh max-w-sm flex-col justify-center gap-6 px-4">
      <div className="space-y-1 text-center">
        <h1 className="text-2xl font-semibold text-foreground">{t("app.name")}</h1>
        <p className="text-sm text-muted">{t("auth.signInPrompt")}</p>
      </div>

      <div className="flex flex-col gap-3">
        {/* Plain anchors, not router links: the IdP round trip is a real
            navigation off this origin, and a client-side route change
            would never leave the SPA. */}
        <Button asChild tooltip={t("tooltips.signInGoogle")}>
          <a href={loginUrl("google", returnTo)}>{t("auth.signInWithGoogle")}</a>
        </Button>
        <Button asChild variant="secondary" tooltip={t("tooltips.signInMicrosoft")}>
          <a href={loginUrl("microsoft", returnTo)}>{t("auth.signInWithMicrosoft")}</a>
        </Button>
      </div>
    </main>
  );
}
